// extracted by mini-css-extract-plugin
export default {"wrapper":"LeSDRXjmbNMoOOqQHY4w","row":"U7uHVDfpCHlND_zSPAfj","nextBtn":"Vcn9PsHNfPIdG71VL6aH"};